<style lang="scss" scoped>
.status-table {
  td {
    // border: 1px solid #f1f1f1;
  }
}
</style>

<template>
  <ConfigPage :max-width="1200">
    <ConfigItem title="Status">
      <v-card outlined>
        <v-list>
          <v-list-item
            link
            class="primary--text"
            :to="{ name: 'configs.leads.statuses.insurers' }"
          >
            <v-list-item-content>
              <v-list-item-title>
                {{ __("portal das companhias") }}
              </v-list-item-title>
            </v-list-item-content>
            <v-list-item-action>
              <v-icon color="primary">mdi-chevron-right</v-icon>
            </v-list-item-action>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item
            :to="{ name: 'configs.leads.statuses.unities' }"
            link
            class="primary--text"
          >
            <v-list-item-content>
              <v-list-item-title>
                {{ __("unidades") }}
              </v-list-item-title>
            </v-list-item-content>
            <v-list-item-action>
              <v-icon color="primary">mdi-chevron-right</v-icon>
            </v-list-item-action>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item
            :to="{ name: 'configs.leads.statuses.experts' }"
            link
            class="primary--text"
          >
            <v-list-item-content>
              <v-list-item-title>
                {{ __("Peritos") }}
              </v-list-item-title>
            </v-list-item-content>
            <v-list-item-action>
              <v-icon color="primary">mdi-chevron-right</v-icon>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-card>
    </ConfigItem>

    <ConfigItem
      :title="__('conversão')"
      :description="
        __(
          'configura os status a serem exibidos no Portal das Companhias, Portal das Unidades de acordo com o Portal HCM'
        )
      "
      class="mt-10"
    >
      <v-card flat>
        <v-alert type="warning" class="mb-4" text outlined>
          {{ __("apenas leads com status convertidos serão exibidas") }}
        </v-alert>
      </v-card>

      <v-card outlined>
        <v-simple-table class="status-table">
          <thead>
            <tr>
              <th>HCM</th>
              <th>{{ __("Companhia") }}</th>
              <th>{{ __("Unidade") }}</th>
              <th>{{ __("Perito") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="status in statuses"
              :key="status.id"
              :class="{ 'warning--text': isStatusWarning(status) }"
            >
              <td :title="getTitleMessage(status)">{{ status.name }}</td>
              <td width="310px">
                <v-autocomplete
                  single-line
                  label="---"
                  :items="insurerStatuses"
                  :value="status.insurer_status_id"
                  @change="updateInsurerStatus(status, $event)"
                  item-text="status"
                  item-value="id"
                  hide-details
                  dense
                  rounded
                  clearable
                ></v-autocomplete>
              </td>
              <td width="310px">
                <v-autocomplete
                  single-line
                  label="---"
                  :items="unityStatuses"
                  :value="status.unity_status_id"
                  @change="updateUnitiesStatus(status, $event)"
                  item-text="status"
                  item-value="id"
                  hide-details
                  rounded
                  dense
                  clearable
                ></v-autocomplete>
              </td>
              <td width="310px">
                <v-autocomplete
                  single-line
                  label="---"
                  :items="expertStatuses"
                  :value="status.expert_status_id"
                  @change="updateExpertsStatus(status, $event)"
                  item-text="status"
                  item-value="id"
                  hide-details
                  rounded
                  dense
                  clearable
                ></v-autocomplete>
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-card>
    </ConfigItem>
  </ConfigPage>
</template>

<script>
import ConfigPage from "@/layouts/configs/ConfigPage";
import ConfigItem from "@/layouts/configs/ConfigItem";
import ToastsMixin from "@/mixins/ToastsMixin";

import {
  index,
  updateUnity,
  updateInsurer,
  updateExpert,
} from "@/services/configs/leads/statuses/status_conversion";

import { index as indexExternal } from "@/services/configs/leads/statuses/external_statuses";

import i18n from "@/mixins/i18n";
export default {
  mixins: [ToastsMixin, i18n],

  components: {
    ConfigPage,
    ConfigItem,
  },

  props: {},

  data() {
    return {
      i18n_prefix: "settings",
      statuses: [],
      unityStatuses: [],
      insurerStatuses: [],
      expertStatuses: [],
    };
  },

  methods: {
    async index() {
      this.statuses = await index();
    },

    async indexUnities() {
      this.unityStatuses = await indexExternal("unities");
    },

    async indexInsurers() {
      this.insurerStatuses = await indexExternal("insurers");
    },

    async indexExperts() {
      this.expertStatuses = await indexExternal("experts");
    },

    async updateInsurerStatus(status, insurerStatusId) {
      await updateInsurer({
        lead_status_id: status.id,
        insurer_status_id: insurerStatusId,
      });
      this.toast("Salvo!");
      this.index();
    },

    async updateUnitiesStatus(status, unityStatusId) {
      await updateUnity({
        lead_status_id: status.id,
        unity_status_id: unityStatusId,
      });
      this.toast("Salvo!");
      this.index();
    },

    async updateExpertsStatus(status, expertStatusId) {
      await updateExpert({
        lead_status_id: status.id,
        expert_status_id: expertStatusId,
      });
      this.toast("Salvo!");
      this.index();
    },

    isStatusWarning(status) {
      return !status.unity_status_id || !status.insurer_status_id;
    },

    getTitleMessage(status) {
      if (!status.unity_status_id && !status.insurer_status_id) {
        return `Leads no status ${status.name} serão vistas somente no Portal HCM`;
      }

      if (!status.unity_status_id) {
        return `Leads no status ${status.name} não serão vistas no Portal das Unidades`;
      }

      if (!status.insurer_status_id) {
        return `Leads no status ${status.name} não serão vistas no Portal das Companhias`;
      }
    },
  },

  computed: {},

  created() {
    this.index();

    this.indexInsurers();
    this.indexUnities();
    this.indexExperts();
  },
};
</script>
